/**
 * CSRFトークンをCookieから取得
 */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  if (match) {
    return decodeURIComponent(match[1]);
  }
  return null;
}

/**
 * CSRFトークンをローカルストレージから取得（fallback）
 */
export function getCsrfTokenFromStorage(): string | null {
  return localStorage.getItem('csrf_token');
}

/**
 * CSRFトークンをローカルストレージに保存
 */
export function setCsrfTokenToStorage(token: string): void {
  localStorage.setItem('csrf_token', token);
}

/**
 * Antd Uploadコンポーネント用のヘッダーを取得
 */
export function getUploadHeaders(): { [key: string]: string } {
  const csrfToken = getCsrfToken();
  const headers: { [key: string]: string } = {
    'X-Requested-With': 'XMLHttpRequest',
  };
  if (csrfToken) {
    headers['X-CSRF-TOKEN'] = csrfToken;
  }
  return headers;
}

/**
 * Fetch APIをラップして、自動的にCSRFトークンをヘッダーに追加
 */
export function fetchWithCsrf(url: string, init?: RequestInit): Promise<Response> {
  // 常にクッキーから最新のトークンを取得（ローカルストレージは使わない）
  const csrfToken = getCsrfToken();

  console.log('[fetchWithCsrf]', url, 'CSRF Token:', csrfToken ? 'exists' : 'missing');

  const headers: any = Object.assign(
    {},
    init && init.headers ? init.headers : {},
    { 'X-Requested-With': 'XMLHttpRequest' }
  );

  if (csrfToken) {
    headers['X-CSRF-TOKEN'] = csrfToken;
  }

  const fetchOptions = Object.assign(
    {},
    init || {},
    {
      credentials: 'include', // Cookieを含める
      headers: headers,
    }
  );

  return fetch(url, fetchOptions).then((response) => {
    // 認証エラー（401）またはセッション切れ（419）の場合、ログインページにリダイレクト
    if (response.status === 401 || response.status === 419) {
      // ログインAPIへのリクエストの場合はリダイレクトしない
      if (!url.includes('/login')) {
        // 現在のパスに応じてリダイレクト先を決定
        const currentPath = window.location.pathname;
        if (currentPath.startsWith('/kix-gbc')) {
          window.location.href = '/kix-gbc/#/login';
        } else if (currentPath.startsWith('/useradmin')) {
          window.location.href = '/useradmin/#/login';
        } else {
          window.location.href = '/admin/#/login';
        }
      }
    }
    return response;
  });
}
